import {
  FETCH_USERS_BEGIN,
  FETCH_USERS_ERROR,
  FETCH_USERS_SUCCESS,
} from "../actions/types"

const initialState = {
  byId: {},
  error: null,
  isLoading: false,
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_USERS_BEGIN:
      return { ...state, isLoading: true, error: null }
    case FETCH_USERS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        byId: action.payload,
      }
    case FETCH_USERS_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      }
    default:
      return state
  }
}

export default reducer
